import { useMemo } from 'react';
import type { TeamDifficultyPricing, TeamWithMemberCount } from '@aegislab/shared';
import { useTeams } from './useTeamQueries';

export interface TeamData {
  allTeams: TeamWithMemberCount[];
  activeTeams: TeamWithMemberCount[];
  teamNameMap: Map<string, string>;
  teamPricing: Record<string, TeamDifficultyPricing | null>;
  isLoading: boolean;
}

/**
 * 팀 데이터를 관리하는 훅
 *
 * - 전체 팀 목록 조회
 * - 활성 팀 필터링 (status === 'active')
 * - 팀 ID → 이름 매핑 (빠른 조회를 위한 Map)
 */
export function useTeamData(): TeamData {
  const { data: allTeams, isLoading } = useTeams();

  const activeTeams = useMemo(() => {
    return allTeams?.filter((t) => t.status === 'active') ?? [];
  }, [allTeams]);

  const teamNameMap = useMemo(() => {
    return new Map(allTeams?.map((t) => [t.id, t.name]) ?? []);
  }, [allTeams]);

  // 팀 id → 난이도 단가표(`GET /teams/list` 가 싣는다). 퀘스트 금액 판정·ⓘ 가 읽는다(퀘스트 540e5d83).
  const teamPricing = useMemo(
    () => Object.fromEntries(allTeams?.map((t) => [t.id, t.difficultyPricing ?? null]) ?? []),
    [allTeams]
  );

  return {
    allTeams: allTeams ?? [],
    activeTeams,
    teamNameMap,
    teamPricing,
    isLoading,
  };
}
